(() => {
  const CATEGORY_ORDER = ['reinigen', 'vorbereiten', 'pflegen', 'abschliessen'];

  function initSkinQuiz(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const dataScript = root.querySelector('[data-skin-quiz-data]');
    let data = { questions: [], products: {}, categoryPriority: {}, uiText: {} };
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }

    const questions = data.questions || [];
    const products = data.products || {};
    const categoryPriority = data.categoryPriority || {};
    const uiText = data.uiText || {};
    const categoryLabels = uiText.categoryLabels || {};
    const totalSteps = questions.length;

    const stepsEl = root.querySelector('[data-skin-quiz-steps]');
    const progressEl = root.querySelector('[data-skin-quiz-progress]');
    const resultsStepEl = root.querySelector('[data-skin-quiz-result-step]');
    const resultTagsEl = root.querySelector('[data-skin-quiz-result-tags]');
    const resultRoutineEl = root.querySelector('[data-skin-quiz-result-routine]');
    const restartBtn = root.querySelector('[data-skin-quiz-restart]');
    const ctaBtn = root.querySelector('[data-skin-quiz-cta]');
    const introEl = root.querySelector('[data-skin-quiz-intro]');
    const startBtn = root.querySelector('[data-skin-quiz-start]');

    if (startBtn) {
      startBtn.addEventListener('click', () => {
        if (introEl) introEl.hidden = true;
        if (progressEl) progressEl.hidden = false;
        if (stepsEl) stepsEl.hidden = false;
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    const answers = {}; // questionIndex -> answer object

    function renderProgress(currentStep) {
      const segments = progressEl.querySelectorAll('[data-skin-quiz-segment]');
      segments.forEach((seg, i) => {
        seg.classList.toggle('is-active', i < currentStep);
      });
      const counter = progressEl.querySelector('[data-skin-quiz-counter]');
      if (counter) counter.textContent = `${Math.min(currentStep + 1, totalSteps)} ${uiText.counterOf || 'von'} ${totalSteps}`;
    }

    function goToStep(index) {
      const allSteps = stepsEl.querySelectorAll('[data-skin-quiz-step]');
      allSteps.forEach((step) => {
        step.classList.toggle('is-active', Number(step.dataset.skinQuizStep) === index);
      });
      resultsStepEl.classList.remove('is-active');
      renderProgress(index);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function selectAnswer(questionIndex, answerHandle) {
      const question = questions[questionIndex];
      const answer = question.answers.find((a) => a.handle === answerHandle);
      answers[questionIndex] = answer;

      const stepEl = stepsEl.querySelector(`[data-skin-quiz-step="${questionIndex}"]`);
      stepEl.querySelectorAll('[data-skin-quiz-option]').forEach((opt) => {
        opt.classList.toggle('is-selected', opt.dataset.skinQuizOption === answerHandle);
      });

      window.setTimeout(() => {
        if (questionIndex + 1 < totalSteps) {
          goToStep(questionIndex + 1);
        } else {
          renderResults();
        }
      }, 150);
    }

    function computeRoutine() {
      const votes = {}; // productHandle -> count
      Object.values(answers).forEach((answer) => {
        (answer.produkte || []).forEach((handle) => {
          votes[handle] = (votes[handle] || 0) + 1;
        });
      });

      const routine = {};
      CATEGORY_ORDER.forEach((cat) => {
        const priorityList = categoryPriority[cat] || [];
        let best = null;
        let bestVotes = -1;
        priorityList.forEach((handle) => {
          const v = votes[handle] || 0;
          if (v > bestVotes) {
            bestVotes = v;
            best = handle;
          }
        });
        routine[cat] = best;
      });
      return routine;
    }

    function tagLabel(questionIndex) {
      const answer = answers[questionIndex];
      if (!answer || !answer.ergebnis_tag) return null;
      return answer.ergebnis_tag;
    }

    function renderResults() {
      const routine = computeRoutine();

      resultTagsEl.innerHTML = '';
      [0, 1, 2].forEach((qi) => {
        const label = tagLabel(qi);
        if (!label) return;
        const tag = document.createElement('span');
        tag.className = 'skin-quiz__tag';
        tag.textContent = label;
        resultTagsEl.appendChild(tag);
      });

      resultRoutineEl.innerHTML = '';
      CATEGORY_ORDER.forEach((cat, i) => {
        const handle = routine[cat];
        const product = products[handle];
        if (!product) return;

        const card = document.createElement('div');
        card.className = 'skin-quiz__routine-card';

        const media = document.createElement('a');
        media.className = 'skin-quiz__routine-media';
        media.href = product.url;
        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.loading = 'lazy';
          img.alt = product.title;
          media.appendChild(img);
        }

        const body = document.createElement('div');
        body.className = 'skin-quiz__routine-body';

        const step = document.createElement('p');
        step.className = 'skin-quiz__routine-step';
        const stepCategoryLabel = product.stepLabelOverride || categoryLabels[cat] || cat;
        step.textContent = `${uiText.stepWord || 'Schritt'} ${i + 1} · ${stepCategoryLabel.toUpperCase()}`;

        const title = document.createElement('a');
        title.className = 'skin-quiz__routine-title';
        title.href = product.url;
        title.textContent = product.title;

        const formula = document.createElement('p');
        formula.className = 'skin-quiz__routine-formula';
        formula.textContent = product.kurzformel || '';

        const whyLabel = document.createElement('p');
        whyLabel.className = 'skin-quiz__routine-why-label';
        whyLabel.textContent = uiText.whyLabel || 'Warum ausgewählt';

        const why = document.createElement('p');
        why.className = 'skin-quiz__routine-why';
        why.textContent = product.why || uiText.whyFallback || '';

        const freq = document.createElement('span');
        freq.className = 'skin-quiz__routine-chip';
        freq.textContent = product.frequency || uiText.frequencyLabel || 'Morgens & abends';

        body.appendChild(step);
        body.appendChild(title);
        if (formula.textContent) body.appendChild(formula);
        body.appendChild(whyLabel);
        body.appendChild(why);
        body.appendChild(freq);

        card.appendChild(media);
        card.appendChild(body);
        resultRoutineEl.appendChild(card);
      });

      const allSteps = stepsEl.querySelectorAll('[data-skin-quiz-step]');
      allSteps.forEach((step) => step.classList.remove('is-active'));
      resultsStepEl.classList.add('is-active');
      progressEl.querySelectorAll('[data-skin-quiz-segment]').forEach((seg) => seg.classList.add('is-active'));
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });

      root._skinQuizRoutine = routine;
    }

    function updateCartBubble(itemCount) {
      document.querySelectorAll('.cart-bubble__text-count, .cart-bubble__text').forEach((el) => {
        el.textContent = itemCount;
      });
      document.querySelectorAll('.cart-bubble').forEach((el) => {
        el.classList.toggle('visually-hidden', itemCount === 0);
      });
      document.querySelectorAll('cart-icon').forEach((el) => {
        el.classList.toggle('header-actions__cart-icon--has-cart', itemCount > 0);
      });
    }

    if (ctaBtn) {
      ctaBtn.addEventListener('click', () => {
        const routine = root._skinQuizRoutine || computeRoutine();
        const items = CATEGORY_ORDER.map((cat) => products[routine[cat]])
          .filter((p) => p && p.variantId && p.available)
          .map((p) => ({ id: p.variantId, quantity: 1 }));

        if (!items.length) return;

        ctaBtn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        })
          .then((res) => res.json())
          .then(() => fetch('/cart.js').then((res) => res.json()))
          .then((cart) => {
            updateCartBubble(cart.item_count);
            ctaBtn.textContent = uiText.ctaSuccessLabel || 'Zur Routine hinzugefügt ✓';
            window.setTimeout(() => {
              ctaBtn.textContent = ctaBtn.dataset.defaultLabel || 'Komplette Routine entdecken';
              ctaBtn.classList.remove('is-loading');
            }, 2000);
          })
          .catch(() => {
            ctaBtn.classList.remove('is-loading');
          });
      });
    }

    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        Object.keys(answers).forEach((k) => delete answers[k]);
        stepsEl.querySelectorAll('[data-skin-quiz-option]').forEach((opt) => opt.classList.remove('is-selected'));
        goToStep(0);
      });
    }

    stepsEl.querySelectorAll('[data-skin-quiz-option]').forEach((opt) => {
      opt.addEventListener('click', () => {
        const step = opt.closest('[data-skin-quiz-step]');
        selectAnswer(Number(step.dataset.skinQuizStep), opt.dataset.skinQuizOption);
      });
    });

    stepsEl.querySelectorAll('[data-skin-quiz-back]').forEach((btn) => {
      btn.addEventListener('click', () => {
        goToStep(Number(btn.dataset.skinQuizBack));
      });
    });

    renderProgress(0);
  }

  function initAll() {
    document.querySelectorAll('[data-skin-quiz]').forEach(initSkinQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
